import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';

const ConfirmationModal = ({
  cancelButtonLabel,
  children,
  confirmButtonLabel,
  isLoading,
  onCloseModal,
  onConfirmation,
  text,
  title,
  width = undefined,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleCloseModal = useCallback(() => {
    onCloseModal();
    setIsOpen(false);
  }, [onCloseModal]);

  return (
    <ModalWithTemplate
      dataTestId="confirmation-modal"
      footer={
        <>
          <Button
            variant="secondary"
            onClick={onCloseModal}
            dataTestId="confirmation-modal-cancel"
          >
            {cancelButtonLabel ?? __('Cancel')}
          </Button>
          <Button
            dataTestId="confirmation-modal-confirm"
            isLoading={isLoading}
            ml={4}
            onClick={onConfirmation}
          >
            {confirmButtonLabel ?? __('Confirm')}
          </Button>
        </>
      }
      header={title ?? __('Are you sure?')}
      isOpen={isOpen}
      isSticky
      onCloseModal={handleCloseModal}
      screenReadersCloseButtonText={s__(
        'ConfirmationModalAccessibility|Close confirmation window',
      )}
      width={width}
    >
      <Box width="100%" flexDirection="column">
        <Box>{text || children}</Box>
      </Box>
    </ModalWithTemplate>
  );
};

ConfirmationModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  cancelButtonLabel: PropTypes.string,
  children: PropTypes.node,
  confirmButtonLabel: PropTypes.string,
  isLoading: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
};

ConfirmationModal.defaultProps = {
  isLoading: false,
};

export default ConfirmationModal;
